<ng-template #sessionDetailContainer></ng-template>
